import * as React from "react";
const SVGComponent = ({ color = "var(--text-secondary)", ...props }) => (
  <svg
    width={26}
    height={17}
    viewBox="0 0 26 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.63977 0.259017H8.33254L2.5869 16.9255H0.5L7.6392 0.259017H7.63977ZM12.5022 3.414H13.8598L13.9778 6.11495H12.3841L12.5021 3.414H12.5022ZM12.2228 7.4664H14.1227L14.228 11.4385H12.0515L12.2226 7.4664H12.2228ZM9.53181 0.258789H12.5724L12.4866 2.511H13.8761L13.7898 0.258789H16.7862L22.0411 16.9252H14.6208L14.3778 13.3216H11.9719L11.7612 16.9252H4.31953L9.53268 0.258789H9.53181ZM17.9856 0.258789H18.8212L25.5 16.9252H23.7742L17.9853 0.258789H17.9856Z"
      fill={color}
    />
  </svg>
);
export default SVGComponent;
